/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Modify_Clock_TimesInputs */

const en_modify_clock_times = /** @type {(inputs: Modify_Clock_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modify Clock Times`)
};

const fr_modify_clock_times = /** @type {(inputs: Modify_Clock_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier les temps d’horloge`)
};

const de_modify_clock_times = /** @type {(inputs: Modify_Clock_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uhrzeiten ändern`)
};

const it_modify_clock_times = /** @type {(inputs: Modify_Clock_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica gli orari dell'orologio`)
};

const ru_modify_clock_times = /** @type {(inputs: Modify_Clock_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменить время на часах`)
};

const es_modify_clock_times = /** @type {(inputs: Modify_Clock_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificar la hora del reloj`)
};

const zh_cn2_modify_clock_times = /** @type {(inputs: Modify_Clock_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`修改时钟时间`)
};

const ja_modify_clock_times = /** @type {(inputs: Modify_Clock_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時計の時間を変更する`)
};

const hi_modify_clock_times = /** @type {(inputs: Modify_Clock_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घड़ी के समय में बदलाव करें`)
};

const pt_pt2_modify_clock_times = /** @type {(inputs: Modify_Clock_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterar horários do relógio`)
};

/**
* | output |
* | --- |
* | "Modify Clock Times" |
*
* @param {Modify_Clock_TimesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const modify_clock_times = /** @type {((inputs?: Modify_Clock_TimesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Modify_Clock_TimesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_modify_clock_times(inputs)
	if (locale === "de") return de_modify_clock_times(inputs)
	if (locale === "it") return it_modify_clock_times(inputs)
	if (locale === "ru") return ru_modify_clock_times(inputs)
	if (locale === "es") return es_modify_clock_times(inputs)
	if (locale === "zh-CN") return zh_cn2_modify_clock_times(inputs)
	if (locale === "ja") return ja_modify_clock_times(inputs)
	if (locale === "hi") return hi_modify_clock_times(inputs)
	if (locale === "pt-PT") return pt_pt2_modify_clock_times(inputs)
	return en_modify_clock_times(inputs)
});